<template>
    <div>
        <MainTempComp
            ref="mainTempRef"
            :searchOption="data.searchOption"
            :handleSearch="handleSearch"
        >
            <template #header>
                <span style="padding-left: 10px"></span>
                <el-button type="primary" @click="handleSearch">查询</el-button>
            </template>
            <template #main>
                <tableComp :tableData="data.tableData"></tableComp>
            </template>
        </MainTempComp>
    </div>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./infoTable.vue";
import {  apiScwInfoList } from "@/api/requestApis.js";
export default {
    name: "hardwareInfoSetting",
    components: {
        tableComp,
    },
    setup() {
        const mainTempRef = ref(null);

        const data = reactive({
            tableData: [],
            searchOption: [
                {
                    name: "设备编号",
                    type: "input",
                    key: "mid",
                    value: "",
                },
            ],
        });
        const handleSearch = async () => {
            const res = await apiScwInfoList({
                size: mainTempRef.value.pageSize,
                current: mainTempRef.value.currentPage,
                ...mainTempRef.value.searchParams,
            });
            mainTempRef.value.setTotalValue(res.total || 0);
            console.log("===>",res)
            data.tableData = res.records || [];
        };

        const handleUpdateTable = () => {
            mainTempRef.value.setPageValue(1);
            handleSearch();
        };
        provide("handleUpdateTable", handleUpdateTable);
        provide("handleSearch", handleSearch);
        onMounted(() => {
            handleSearch();
        });
        return {

            mainTempRef,
            data,
            handleSearch,
        };
    },
};
</script>

<style scoped>
</style>
